import React from "react";
import { Button, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

const LanguageSwitcher = ({ isRTL }) => {
  const {
    currentLanguage,
    changeLanguage,
    availableLanguages,
    isI18nReady,
  } = useLanguage();

  // Find current language object
  const currentIndex = availableLanguages.findIndex(
    (lang) => lang.code === currentLanguage
  );
  
  const currentLang = availableLanguages[currentIndex];

  // Function to cycle to the next language
  const handleToggle = () => {
    const nextIndex = (currentIndex + 1) % availableLanguages.length;
    const nextLang = availableLanguages[nextIndex];
    changeLanguage(nextLang.code);
  };

  if (!isI18nReady) {
    return (
      <Button
        type="text"
        icon={<GlobalOutlined className="animate-spin-slow" />}
        className="text-gold opacity-50"
        disabled
      />
    );
  }
  return (
    <Tooltip title={` ${currentLang?.nativeName || 'Language'}`}>
      <Button
        type=""
        onClick={handleToggle}
        className="flex items-center justify-center w-6 h-6 md:w-9 border-0 md:border  md:border-2 md:border-secondary_hover  hover:bg-primary !text-primary hover:!text-white md:h-9 gap-2  transition-all p-1 md:pb-1.5  rounded-full"
      >
        <GlobalOutlined  className="text-lg md:text-xl " />

      </Button>
     </Tooltip>
  );
};

export default LanguageSwitcher;